// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames not based on template
	if (chunkId === 306) return "platform/js/vendor~player.js";
	if (chunkId === 661) return "platform/js/playlist-playback.js";
	if (chunkId === 25) return "platform/js/membership-update-page.js";
	if (chunkId === 348) return "platform/js/song.js";
	if (chunkId === 879) return "platform/js/report-user.js";
	if (chunkId === 647) return "platform/js/comments-catalogue-component.js";
	if (chunkId === 253) return "platform/js/forum-thread-component.js";
	if (chunkId === 422) return "platform/js/cart-sidebar.js";
	if (chunkId === 394) return "platform/js/nav-cart-button.js";
	if (chunkId === 618) return "platform/js/contact-email-form-marketing.js";
	if (chunkId === 161) return "platform/js/contact-email-form.js";
	if (chunkId === 342) return "platform/js/onboarding-component.js";
	if (chunkId === 776) return "platform/js/video-player-component.js";
	if (chunkId === 206) return "platform/js/video-media-element-component.js";
	if (chunkId === 948) return "platform/js/image-cropper-component.js";
	// return url for filenames based on template
	return "" + "/platform/js/vendor" + ".js";
};